module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-right": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "¿Qué son los ingresos fijos?",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("¿Qué son los "), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" ingresos fijos?")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only ",
    attrs: {
      "xs12": "",
      "sm2": "",
      "text-xs-right": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInRight",
    attrs: {
      "imaSize": 250,
      "imaSrc": "design/banco1-1-3-2",
      "imaAlt": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¿Qué son los ingresos fijos?',
      "videoEmbed": "ADMINISTRACIONDINERO20QueSonIngresosFIjos (51).mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeIn dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 500,
      "imaSrc": "contenido/diapositiva_21",
      "imaAlt": "Mano escogiendo una bolsa de monedas"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "text-box adorn-bottom"
  }, [_vm._v("\n        Son aquellos que una persona recibe de manera "), _c('strong', [_vm._v("estable")]), _vm._v(" y "), _c('strong', [_vm._v("repetitiva")]), _vm._v(" en cada periodo de tiempo\n            y por el mismo valor. Por ejemplo, el "), _c('strong', [_vm._v("salario")]), _vm._v(" o la "), _c('strong', [_vm._v("renta")]), _vm._v(" de un apartamento que se encuentre alquilado.\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-571a49d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-20.vue
// module id = 991
// module chunks = 1